import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_3 = { class: "p-col-8 p-sm-8 p-md-9 p-p-0 p-m-0 kn-page" }
const _hoisted_4 = { class: "kn-list--column kn-list-border-left p-col-4 p-sm-4 p-md-3 p-p-0" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "pi pi-bars" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GlossaryDefinitionInfoDialog = _resolveComponent("GlossaryDefinitionInfoDialog")
  const _component_GlossaryDefinitionDetail = _resolveComponent("GlossaryDefinitionDetail")
  const _component_FabButton = _resolveComponent("FabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Button = _resolveComponent("Button")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_GlossaryDefinitionWordEdit = _resolveComponent("GlossaryDefinitionWordEdit")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(_component_GlossaryDefinitionInfoDialog, {
        visible: _ctx.infoDialogVisible,
        contentInfo: _ctx.contentInfo,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.infoDialogVisible = false))
      }, null, 8, ["visible", "contentInfo"]), [
        [_vShow, _ctx.infoDialogVisible]
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_GlossaryDefinitionDetail, {
          reloadTree: _ctx.reloadTree,
          onInfoClicked: _ctx.showInfo,
          onAddWord: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editWord(-1, $event)))
        }, null, 8, ["reloadTree", "onInfoClicked"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.glossary.glossaryDefinition.wordsList')), 1)
          ]),
          end: _withCtx(() => [
            _createVNode(_component_FabButton, {
              icon: "fas fa-plus",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.editWord(-1)), ["stop"])),
              "data-test": "new-button"
            })
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar",
              "data-test": "progress-bar"
            }))
          : _createCommentVNode("", true),
        (!_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Listbox, {
              key: 1,
              class: "kn-list--column ",
              options: _ctx.wordsList,
              filter: true,
              filterPlaceholder: _ctx.$t('common.search'),
              filterMatchMode: "contains",
              filterFields: _ctx.glossaryDefinitionDescriptor.filterFields,
              emptyFilterMessage: _ctx.$t('common.info.noDataFound'),
              "data-test": "words-list"
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
              ]),
              option: _withCtx((slotProps) => [
                _createVNode("div", {
                  class: "kn-list-item kn-draggable",
                  draggable: "true",
                  onDragstart: ($event: any) => (_ctx.onDragStart($event, slotProps.option)),
                  "data-test": "list-item"
                }, [
                  _hoisted_5,
                  _createVNode("div", {
                    class: "kn-list-item-text",
                    onClick: _withModifiers(($event: any) => (_ctx.editWord(slotProps.option.WORD_ID)), ["stop"])
                  }, [
                    _createVNode("span", null, _toDisplayString(slotProps.option.WORD), 1)
                  ], 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    icon: "pi pi-info-circle",
                    class: "p-button-text p-button-rounded p-button-plain",
                    onClick: _withModifiers(($event: any) => (_ctx.showInfo(slotProps.option)), ["stop"]),
                    "data-test": "info-button"
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    icon: "far fa-trash-alt",
                    class: "p-button-text p-button-rounded p-button-plain",
                    onClick: _withModifiers(($event: any) => (_ctx.deleteWordConfirm(slotProps.option.WORD_ID)), ["stop"]),
                    "data-test": "delete-button"
                  }, null, 8, ["onClick"])
                ], 40, ["onDragstart"])
              ]),
              _: 1
            }, 8, ["options", "filterPlaceholder", "filterFields", "emptyFilterMessage"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_GlossaryDefinitionWordEdit, {
      visible: _ctx.editWordDialogVisible,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editWordDialogVisible = false)),
      onSaved: _ctx.wordSaved,
      state: _ctx.state,
      category: _ctx.category,
      propWord: _ctx.contentInfo,
      selectedGlossaryId: _ctx.selectedGlossaryId,
      onReloadTree: _cache[5] || (_cache[5] = ($event: any) => (_ctx.reloadTree = !_ctx.reloadTree))
    }, null, 8, ["visible", "onSaved", "state", "category", "propWord", "selectedGlossaryId"])
  ]))
}